const filter = [
  {
    service: {
      folder: 'bibliotecas',
      file: 'Bibliotecas',
      relationship: ''
    },
    listLabel: 'biblioteca',
    label: 'Biblioteca',
    itemValue: 'id',
    itemText: 'apelido',
    id: 'biblioteca_id'
  },
  {
    service: {
      folder: 'organizacao',
      file: 'funcoes',
      relationship: ''
    },
    listLabel: 'nome',
    label: 'Funções',
    itemValue: 'nome',
    itemText: 'nome',
    id: 'funcao_id'
  }
]
export default filter
